import "../App.css";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Link as Link2 } from "react-scroll";
import menu from "../Assets/Menu.svg";

// `onOpenWork`, when provided, adds a "Work" item that opens the
// browse-all-case-studies drawer instead of navigating — used on pages
// (About, Archives) that don't have their own inline "View All Case
// Studies" entry point the way the case-study detail page does. Omitted
// entirely (e.g. on the home page) when the prop isn't passed.
function MobileMenu({ onOpenWork }) {
  const [isOpen, setIsOpen] = useState(false);
    const [rotation, setRotation] = useState(0);
  const lastScrollY = useRef(0);
   useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY.current;

      setRotation((prev) => (scrollingDown ? prev - 15 : prev + 15));

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        className="mobile-menu-trigger"
        onClick={() => setIsOpen(true)}
        aria-label="Open menu"
      >
        <img src={menu} alt="Menu" style={{ transform: `rotate(${rotation}deg)` }} />
      </button>

      <div
        className={`mobile-menu-backdrop ${isOpen ? "open" : ""}`}
        onClick={closeMenu}
      ></div>

      <div className={`mobile-menu-sheet ${isOpen ? "open" : ""}`}>
        <button
          type="button"
          className="mobile-menu-close"
          onClick={closeMenu}
          aria-label="Close menu"
          
        >
          ■ Close
        </button>

        <nav className="mobile-menu-links">
          <Link to="/" className="mobile-menu-item" onClick={closeMenu}>
            Home
          </Link>
           {onOpenWork && (
            <button
              type="button"
              className="mobile-menu-item mobile-menu-item-button"
              onClick={() => {
                closeMenu();
                onOpenWork();
              }}
            >
              Work
            </button>
          )}
          <Link to="/archives" className="mobile-menu-item" onClick={closeMenu}>
            Archives
          </Link>
          <Link to="/about" className="mobile-menu-item" onClick={closeMenu}>
            About Me
          </Link>
         
          <Link2
            activeClass="active"
            to="contact"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            className="mobile-menu-item"
            onClick={closeMenu}
          >
            Let's Connect
          </Link2>
        </nav>
      </div>
    </>
  );
}

export default MobileMenu;